import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

import './styles.scss';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertModal({ open, title, content, buttonText, onButtonClick, secondButtonText = null, onSecondButtonClick = null, ...restProps }) {
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={()=>{}}
        {...restProps}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions className='alert-modal-button-container'>
          <Button onClick={onButtonClick} variant="contained">{buttonText}</Button>
          {secondButtonText ? (
            <Button onClick={onSecondButtonClick} variant="contained">{secondButtonText}</Button>
          ):null}
        </DialogActions>
      </Dialog>
    </div>
  );
}